import { createSelector } from 'reselect';

const getHasLoaded = createSelector(
  (state) => state.findWordsStepThreeExtraLevels.hasLoaded,
  (hasLoaded) => hasLoaded
);
const getCurrencyData = createSelector(
  (state) => state.findWordsStepThreeExtraLevels.data.currency,
  (currency = {}) => currency
);
const getLevelsData = createSelector(
  (state) =>
    state.findWordsStepThreeExtraLevels.data.findWordsStepThreeExtraLevels,
  (levels = []) => levels
);

export default {
  getCurrencyData,
  getHasLoaded,
  getLevelsData,
};
